import { createSelector } from "@reduxjs/toolkit";

import type { IServicesReducerState } from "./reducer";

const getServicesState = (state: { services: IServicesReducerState }): IServicesReducerState => state.services;

export const getServicesData = createSelector(getServicesState, (state) => state.services);

export const getServicesIsFetching = createSelector(getServicesState, (state) => state.isFetching);

export const getServicesHasError = createSelector(getServicesState, (state) => state.hasError);

export const getServicesExists = (state: { services: IServicesReducerState }): boolean => getServicesIsFetching(state) || getServicesData(state) !== null;
